export default {
      id: "Ice-cream-usage",
      viewBox: "0 0 21 42",
      url: __webpack_public_path__ + "img/icons.svg#Ice-cream",
      toString: function () {
        return this.url;
      }
    }